/* @flow */
import { Experiments } from 'constants/ExperimentConstants';
import invariant from 'invariant';

const OVERRIDES_STORAGE_KEY = 'experimentOverrides';

/**
 * Set these values in localStorage. This Chrome extension makes it easy,
 * https://chrome.google.com/webstore/detail/storage-area-explorer/ocfjjjjhkpapocigimmppepjgfdecjkb/related?hl=en
 */
function devOverride(apiKey): ?string {
  const str = window.localStorage.getItem(OVERRIDES_STORAGE_KEY);
  if (str === null) { // not set
    return null;
  }

  try {
    const experimentOverrides = JSON.parse(str);
    const variant = experimentOverrides[apiKey];
    return variant;
  } catch (e) {
    console.error(`Error parsing experiment overrides from '${str}'`, e);
    return null;
  }
}

/**
 * If checkVariant is omitted, check for a default variant named the same as
 * the web key, but lower case.
 */
export function userInExperimentVariant(
  user: {getExperimentVariant: Function},
  webKey: string,
  checkVariant: string = webKey.toLowerCase()): boolean {
  const exp = Experiments[webKey];

  invariant(exp, `Unknown web experiment key '${webKey}'`);

  const { apiKey, validVariants } = exp;

  invariant(validVariants.includes(checkVariant), `currentUserInExperimentVariant called with invalid variant '${checkVariant}'`);

  if (__DEV__) {
    const devOverrideVariant = devOverride(apiKey);
    if (devOverrideVariant) {
      return checkVariant === devOverrideVariant;
    }
  }

  const apiVariant = user.getExperimentVariant(apiKey);

  if (!validVariants.includes(apiVariant)) {
    // This is a little drastic. We could fall back to control but then we'd
    // potentially contaminate our experiments. Instead treat this as a
    // downtime situation and fix it right quick.
    throw new Error(`Experiments API returned invalid variant '${apiVariant}'`);
  }

  return checkVariant === apiVariant;
}



// WEBPACK FOOTER //
// ./src/lib/Experimentation.js